export enum IntegrationPermissionEnum {
  LINK = '1',
  VIDEO = '2',
  EMAIL = '3',
}
